import {assetPath} from "@/shared/utils/asset-path";

const DEFAULT_ICON_PATH = assetPath("/images/icons/checkmark-icon.svg");

const AMENITY_ICON_MAP: Record<number, string | null> = {
    121: "hottub", // Hot tub
    122: "pool", // Pool
    123: "sauna", // Sauna
    124: "tennis", // Tennis court
    125: "oceanfront", // Oceanfront
    126: "oceanview", // Ocean view
    127: "lakefront", // Lakefront
    128: "lakeview", // Lake view
    129: "riverfront", // Riverfront
    132: "crib", // Crib
    133: "highchair", // High chair
    134: "pets", // Dog-friendly
    137: "washerdryer", // Washer/dryer
    138: "jettub", // Jetted tub
    139: "centralac", // Central AC
    140: "partialac", // Partial AC
    141: "woodfireplace", // Wood-burning fireplace
    143: "woodstove", // Wood stove
    144: "gasfireplace", // Gas fireplace
    145: "internet", // Internet
    146: "outdoorfire", // Firepit
    147: "deck", // Deck
    148: "patio", // Patio
    150: "balcony", // Balcony
    151: "gasgrill", // Gas grill
    153: "fridge", // Fridge
    154: "stove", // Stove
    156: "dishwasher", // Dishwasher
    158: "microwave", // Microwave
    177: "cable", // Cable
    178: "dvdplayer", // DVD player
    179: "dvdlibrary", // DVD library
    180: "dvdplayer", // VCR
    181: "dvdlibrary", // VHS library
    182: "stereo", // Stereo
    184: "sounddock", // Sound dock
    185: "pingpong", // Ping-pong table
    186: "pooltable", // Pool table
    187: "fooseball", // Foosball table
    189: "boogieboard", // Boogie board
    190: "kayak", // Canoe available for guest use
    191: "kayak", // Kayaks
    192: "dock", // Dock
    194: "adultgames", // Board games
    195: "adultgames", // Children's games
    196: "beachaccess", // Beach access
    197: "downhillskiing", // Ski-in/ski-out
    200: "mountainview", // Mountain view
    202: "gameroom", // Game room
    203: "walktolifts", // Walk to lifts
    211: "basketballcourt", // Basketball court
    213: "enclosedyard", // Enclosed yard
    215: "weddingvenue", // Wedding venue
    216: "golf", // Golf on-site
    226: "tv", // TV
    227: "adultbikes", // Adult bikes
    228: "adultbikes", // Children's bikes
    241: "dvdplayer", // Blu-Ray player
    242: "pack-n-play", // Pack-N-Play
    243: "babygate", // Baby gates
    245: "beachchair", // Beach chairs
    249: "spaceheater", // Space heater
    256: "netflixstreaming", // Netflix streaming
    257: "tennis", // Badminton
    261: "recreation", // SHARC
    267: "internet", // Wireless router
    268: "gamingsystem", // Gaming system
    269: "fireplace", // Fireplace
    288: "downhillskiing", // Downhill Skiing
    289: "iron", // Iron
    295: "wheelchairaccessible", // Limited mobility access
    296: "wheelchairaccessible", // Wheelchair accessible
    299: "fitnessroom", // Gym/fitness room
    311: "elevator", // Elevator
    316: "meetingroom", // Meeting and events allowed
    319: "pool", // Heated pool
    320: "pool", // Indoor pool
    321: "patio", // Lanai
    325: "playground", // Playground
    353: "horseshoes", // Horseshoes
    387: "electricvehiclecharger", // Electric vehicle charger
    388: "beachtowels", // Beach towels
    400: "waterfront", // Waterfront
    401: "paidparking", // Paid parking only
    409: "pool", // Children's pool
    410: "freecontinentalbreakfast", // Free breakfast
    411: "netflixstreaming", // HBO streaming
    412: "snowbird", // Snowbird-friendly
    441: "nochildren", // Not suitable for children
    507: "oceanview", // Gulf view
    508: "oceanfront", // Gulf-front
    529: "freecontinentalbreakfast", // Bed & breakfast
    541: "sharedbathroom", // Shared Bathroom Only
    556: "pool", // Rooftop pool
    557: "pool", // Infinity pool
    559: "pool", // Saltwater pool
    560: "pool", // Plunge pool
    563: "airportshuttle", // Free airport shuttle
    568: "meetingroom", // Meeting/banquet facilities
    587: "waterview", // Water view
    589: "hammock", // Hammock
    590: "hottub", // Pool spa
    601: "golf", // Disc golf
    602: "golf", // Golf nearby
    605: "patio", // Cabana
    606: "pool", // Lazy River
    607: "gasgrill", // Shared Charcoal Grill
    608: "wheelchairaccessible", // Step-free access
    609: "wheelchairaccessible", // Wide clearance
    610: "wheelchairaccessible", // Accessible bath/shower
    611: "gameroom", // Air Hockey
    612: "buoy", // Buoy
    615: "kayak", // Boat rental available
    617: "basketballcourt", // Volleyball court
    620: "golf", // Golf cart
    624: "guesthouse", // Guest House/Casita
    627: "waterview", // Sound view
    628: "waterfront", // Soundfront
    630: "gasgrill", // Electric grill
    631: "beachaccess", // Beach Gear
    632: "premier", // Premier
    646: "air-conditioning", // Air Conditioning
    250: "air-conditioning", // Air Conditioning
    384: "towels", // Towels
    647: "heating", // Heating
    385: "bed", // Heating
};

export function getAmenityIconPath(amenityId: number): string {
    const iconName = AMENITY_ICON_MAP[amenityId];
    if (!iconName) return DEFAULT_ICON_PATH;
    return assetPath(`/images/icons/amenities/${iconName}.svg`);
}
